export const pricing = {
  "breadcrumb": "Pricing",
  "title": "Simple and flexible pricing",
  "subtitle": "A single 5% commission, paid by whoever you want.",
  "whoPays": {
    "title": "Who pays the fees?",
    "traveler": {
      "label": "Option 1: Traveler pays (Recommended)",
      "description": "You receive 100% of your price. Traveler adds 5% service fee.",
      "badge": "Default"
    },
    "host": {
      "label": "Option 2: Host pays (Pro)",
      "description": "You pay the 5%. Lower displayed price for the traveler, ideal for companies.",
      "badge": "Pro Option"
    }
  },
  "guarantee": "Total transparency guaranteed",
  "perYear": "/year",
  "choose": "Choose",
  "popular": "Most popular",
  "plans": {
    "traveler": {
      "name": "Traveler",
      "description": "To explore the world at lower cost",
      "price": "5%",
      "period": "commission",
      "features": [
        "Access to all properties",
        "Reduced service fees (5%)",
        "Insurance included",
        "24/7 Support",
        "No hidden fees"
      ]
    },
    "host": {
      "name": "Host",
      "description": "To rent without fees and exchange",
      "price": "0%",
      "period": "commission",
      "features": [
        "0% commission on your earnings",
        "Access to free host exchanges",
        "\"Fair Price\" badge available",
        "Increased visibility",
        "Priority support"
      ]
    }
  },
  "fairPrice": {
    "title": "Fair Price Program",
    "description": "Play fair, earn more.",
    "benefit1": "'Fair Price' badge visible",
    "benefit2": "Priority in results",
    "benefit3": "Exchange points bonus",
    "condition": "Offer a rate at least 10% cheaper than on other platforms."
  },
  "taxAdvantage": {
    "title": "Tax & Pro Advantage",
    "text": "The 5% fee may be deductible from your expenses if you are a company. The 0% model simplifies accounting for individuals. Consult your tax expert."
  },
  "hostExchange": {
    "title": "Host Exchange System",
    "description": "Exchange your earned nights for free stays.",
    "free": "Free (€0)",
    "community": "Reserved for verified members"
  },
  "comparison": {
    "title": "Why is it better?",
    "subtitle": "Compare and see the difference",
    "features": "Features",
    "airbnb": "Airbnb / Booking",
    "traveltrok": "DONKEY TRAVEL",
    "hostFees": "Host Fees",
    "travelerFees": "Traveler Fees",
    "exchange": "Free Exchange"
  },
  "testimonials": {
    "title": "What our members say",
    "subtitle": "Join a community that changes the rules",
    "badge": "Testimonials",
    "exchanges": "exchanges",
    "saved": "saved",
    "verifiedMembers": "+15,000 members",
    "completedExchanges": "+50,000 trips",
    "totalSaved": "0% commission"
  },
  "faq": {
    "title": "Frequently asked questions",
    "subtitle": "Everything you need to know about our pricing",
    "q1": {
      "question": "Can I change plans at any time?",
      "answer": "Yes, you can upgrade to a higher plan at any time. The difference will be calculated pro rata to your current subscription."
    },
    "q2": {
      "question": "Are there any additional fees?",
      "answer": "No hidden fees. The displayed price is the final price you pay per year. Exchanges are then completely free."
    },
    "q3": {
      "question": "What happens if I'm not satisfied?",
      "answer": "We offer a 30-day money-back guarantee. If you're not satisfied, we'll refund you in full."
    },
    "q4": {
      "question": "How does billing work?",
      "answer": "You are billed annually. You can pay by credit card or bank transfer. Billing is automatic and you receive an invoice by email."
    },
    "q5": {
      "question": "Can I cancel my subscription?",
      "answer": "Yes, you can cancel at any time. Your subscription will remain active until the end of the paid period."
    }
  },
  "cta": {
    "title": "Ready to start the adventure?",
    "subtitle": "Join thousands of owners who travel for free",
    "createAccount": "Create my account",
    "exploreDestinations": "Explore destinations"
  },
  "signup": {
    "title": "Create your account",
    "subtitle": "Join our community of owners",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phone": "Phone",
    "country": "Country",
    "selectCountry": "Select your country",
    "plan": "Plan",
    "selectPlan": "Select your plan",
    "propertyType": "Property type",
    "selectPropertyType": "Select property type",
    "terms": "I accept the terms of use and privacy policy",
    "submit": "Create my account",
    "success": "Account created successfully!",
    "error": "An error occurred. Please try again.",
    "securityNote": "Your data is secure and will never be shared",
    "house": "House",
    "apartment": "Apartment",
    "villa": "Villa",
    "loft": "Loft",
    "other": "Other"
  },
  "signupSection": {
    "title": "Join DONKEY TRAVEL today",
    "subtitle": "Create your account in minutes and start exchanging your property with owners from around the world.",
    "verifiedMembers": "Verified members",
    "verifiedMembersDesc": "All our members are verified Airbnb owners for exchanges with complete confidence.",
    "guaranteedSavings": "Guaranteed savings",
    "guaranteedSavingsDesc": "Our members save an average of €3,500 per year on their accommodation costs.",
    "globalNetwork": "Global network",
    "globalNetworkDesc": "Access over 15,000 properties in 85 countries around the world.",
    "responsiveSupport": "Responsive support",
    "responsiveSupportDesc": "Our team is available 7 days a week to help you with your exchanges."
  },
  "testimonialItems": {
    "sophie": "Thanks to DONKEY TRAVEL, I visited Barcelona, Rome and Amsterdam without paying accommodation. The community is responsive and exchange discussions are easy.",
    "thomas": "I joined the 2026 launch offer: 50% off in year one. The price is guaranteed for life for the first 1,000 members, and I can exchange across Europe.",
    "marie": "I finally made my first exchange in Europe, and everything was smooth from the first message to arrival. Profile verification really helps.",
    "pierre": "For our properties, the dashboard saves us time: listings, messages and availability are clear and easy to manage."
  }
};
